export const SESSION_STORAGE_SCOPE = "AUTH";